<template>
  <el-card
    v-loading="finalizedDisputes == null"
    shadow="hover"
    class="box-card"
    body-style="padding: 16px; padding-top: 8px;"
  >
    <div slot="header" class="clearfix">
      <span>Finalized Disputes</span>
    </div>
    <span v-if="finalizedDisputes == null" class="center-message">No Disputes</span>
    <div v-else>
      <div
        v-for="dispute in finalizedDisputes"
        :key="dispute.o_id"
        class="text item"
        @click="showDispute(dispute, false)"
      >
        <div class="list-tile">
          <span
            class="list-title"
          >{{ getFullName(dispute.attendance_record.user) + ' - ' + dispute.dispute_type.name }}</span>
          <div style="display: flex">
            <span
              class="list-subtext"
              style="margin-right: auto;"
            >{{ dispute.attendance_record.event.date + ' - ' + dispute.attendance_record.event.event_type.name }}</span>
            <span class="list-subtext">
              <i
                v-if="dispute.filename != null"
                style="vertical-align: middle; font-size: 14px;"
                class="material-icons"
              >attach_file</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <nxs-dispute-modal
      ref="disputeModal"
      v-model="tempDispute"
      @save="disputeSaved"
      :approve="true"
    />
  </el-card>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {
            finalizedDisputes: null,
            tempDispute: null
        };
    },
    created() {
        if (
            !this.$store.getters.hasPermission(["All", "Dispute-Approve", "Disputes"])
        )
            this.$router.push("/admin");
    },
    computed: {
        ...mapFields(["user", "users", "permissions", "selectedTerms"]),

        canApprove() {
            return this.$store.getters.hasPermission([
                "Dispute-Approve",
                "Disputes",
                "All"
            ]);
        }
    },
    watch: {
        selectedTerms(){
            this.getFinalizedDisputes();
        }
    },
    mounted() {
        if (this.dispute_types == null) this.$store.dispatch("pullDisputeTypes");
        if (this.levels == null) this.$store.dispatch("pullLevels");
        if (this.canApprove) this.getFinalizedDisputes();
    },
    methods: {
        disputeSaved(value) {
            var ind = this.finalizedDisputes.findIndex((e) => e.o_id == value.o_id);
            this.finalizedDisputes.splice(ind, 1);
        },
        showDispute(dispute) {
            this.tempDispute = dispute;
            this.$refs.disputeModal.open();
        },
        getFinalizedDisputes() {
            this.axios
                .get("/api/v1/attendance/disputes", {
                    params: {
                        terms: this.selectedTerms,
                        status: 'finalized'
                    },
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.finalizedDisputes = response.data;
                })
                .catch((err) => {
                    console.error(err);
                    this.$message({
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        }
    }
};
</script>
